import type { DatabaseFieldType } from '@databases/types/database';

const getSearchableText = (value: string): string => value.toLocaleLowerCase();

export const includesSearch = (value: string, searchValue: string): boolean =>
  getSearchableText(value).includes(getSearchableText(searchValue));

/**
 * Returns true when the menu should offer the given field type. When no `showTypes`
 * allowlist is passed, every field type is visible.
 */
export const isFieldTypeVisible = (
  type: DatabaseFieldType,
  showTypes?: DatabaseFieldType[]
): boolean => !showTypes || showTypes.includes(type);
